export const ModalboxConfig = {
    componentTypeKey: 'Modalbox',

    htmlId: 'modalbox',
    baseHtmlClass: 'modalbox',
    selector: '.modalbox',

    datasetConfigKey: 'modalbox_config',

    uninitializedHtmlClass: 'modalbox--uninited',
    initializedHtmlClass: 'modalbox--inited',
    notInitializedSelector: '.modalbox:not(.modalbox--inited)',

    loadedEventName: 'Rankers.Modalbox:Loaded',
    initializedEventName: 'Rankers.Modalbox:Initialized',
    closeEventName: 'Rankers.Modalbox:Close',
    openEventName: 'Rankers.Modalbox:Open',
    contentChangeEventName: 'Rankers.Modalbox:ContentChanged',
};
